import { LeftArrow, Headset } from 'assets/icons/components'
import { setMainContent, logout, setIsFullScreen, setRegisterModal } from 'actions'
import { connect } from 'react-redux'
import { useRouter } from 'next/router'
import Cookies from 'js-cookie'
import { AuthServices } from 'services'
import { useTranslation } from 'react-i18next'
import { LanguageSelect } from 'components/common/index'
import i18n from 'config/i18n'
import { X, Facebook, Instagram } from 'assets/icons/components'

import {
  SocialsContainer,
  SocialItem,
  LanguageContainer,
  SupportLink
} from './style'

const Settings = (props) => {
  const { setActiveTab, contentKey, dispatch, user, echoServer } = props
  const { t } = useTranslation('live', { i18n })
  const router = useRouter()
  const tabs = [
    {
      key: 'story',
      label: t('Story')
    },
    {
      key: 'chat-rules',
      label: t('Chat rules')
    },
    {
      key: 'payment-history',
      label: t('Transaction history')
    },
    {
      key: 'monetization',
      label: t('Monetization')
    },
    {
      key: 'about-us',
      label: t('About us')
    },
  ]

  const changeContent = (tab) => {
    dispatch(setMainContent(tab))
    dispatch(setIsFullScreen(false))
  }

  const back = () => {
    setActiveTab('video-chat')
    if (contentKey !== 'messages') {
      dispatch(setMainContent('dashboard'))
    }
  }

  const handleLogout = () => {
    AuthServices.logout()
    dispatch(logout())
    Cookies.remove('accessToken')

    if (echoServer) {
      echoServer.disconnect()
    }

    router.push('/trial')
  }

  const handleRegister = () => {
    dispatch(setRegisterModal(true))
  }

  return (
    <div className='sidebar__settings'>
      {/* <div className='settings__header'>
        <div className='header__heading'>{ t('Settings') }</div>
        <div className='header__back' onClick={() => back()}>
          <LeftArrow className='back__icon' />
        </div>
      </div> */}
      <div className='settings__body'>
        { user?.role === 'guest' && <>
          <div
            onClick={() => handleRegister()}
            className="body__tab-wrapper"
            key="register" >
            <div className='tab-wrapper__label'>{ t('Register') }</div>
          </div>
        </>}
        { user?.role !== 'guest' && <>
          {tabs.map(tab => {
            if (tab.key === 'monetization' && user.gender !== 1 || tab.key === 'story' && user?.monetization_status !== 3) {
              return ''
            }
            return (
              <div
                onClick={() => changeContent(tab.key)}
                className={`body__tab-wrapper ${contentKey === tab.key ? 'body__tab-wrapper--selected' : ''}`}
                key={tab.key} >
                <div className='tab-wrapper__label'>{tab.label}</div>
              </div>
            )
          })}
        </>}
        {/* <div
          onClick={() => handleLogout()}
          className='body__tab-wrapper'>
          <div className='tab-wrapper__label tab-wrapper__label--log-out'>{ t('Log out') }</div>
        </div> */}
        <SocialsContainer>
          <SocialItem href='https://x.com/flirtbees' target="_blank">
            <X  />
          </SocialItem>
          <SocialItem href='https://fb.com/flirtbees' target="_blank">
            <Facebook />
          </SocialItem>
          <SocialItem href='https://instagram.com/flirtbees' target="_blank">
            <Instagram  />
          </SocialItem>
        </SocialsContainer>

        <LanguageContainer>
          <LanguageSelect text={t('Language')} key="locales"/>
        </LanguageContainer>
        {
          user?.role === 'user'
          ?
            <SupportLink
              onClick={() => changeContent('support')}>
              <Headset /> { t('Support') }
            </SupportLink>
          : <></>
        }
      </div>
    </div>
  )
}


const mapStateToProps = (state) => ({
  contentKey: state.mainContentReducer.contentKey,
  socket: state.connectionReducer.socket,
  user: state.connectionReducer.user,
  echoServer: state.connectionReducer.echoServer,
})

export default connect(mapStateToProps)(Settings)
